import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as ChevronUpIcon } from './chevronUp.svg';

export const ChevronUp = IconHOC(ChevronUpIcon);
